import AccountCircle from "@mui/icons-material/AccountCircle";
import Chat from "@mui/icons-material/Chat";
import CurrencyExchange from "@mui/icons-material/CurrencyExchange";
import Dashboard from "@mui/icons-material/Dashboard";
import Gavel from "@mui/icons-material/Gavel";
import Mail from "@mui/icons-material/Mail";
import Newspaper from "@mui/icons-material/Newspaper";
import PriorityHigh from "@mui/icons-material/PriorityHigh";
import Subtitles from "@mui/icons-material/Subtitles";
import List from "@mui/material/List";
import { useTranslation } from "react-i18next";
import { NavigationButton } from "./NavigationButton";

interface NavigationProps {
  collapsed?: boolean;
}

export const Navigation = (props: NavigationProps) => {
  const { collapsed } = props;
  const { t } = useTranslation();

  return (
    <List disablePadding>
      <NavigationButton
        href="/accounts"
        icon={<AccountCircle />}
        showTooltip={collapsed}
        text={String(t("Navigation.accounts"))}
      />
      <NavigationButton
        href="/anticheat"
        icon={<Gavel />}
        showTooltip={collapsed}
        text={String(t("Navigation.anticheat"))}
      />
      <NavigationButton
        href="/chats"
        icon={<Chat />}
        showTooltip={collapsed}
        text={String(t("Navigation.chats"))}
      />
      <NavigationButton
        href="/dashboard"
        icon={<Dashboard />}
        showTooltip={collapsed}
        text={String(t("Navigation.dashboard"))}
      />
      <NavigationButton
        href="/mails"
        icon={<Mail />}
        showTooltip={collapsed}
        text={String(t("Navigation.mails"))}
      />
      <NavigationButton
        href="/news-events"
        icon={<Newspaper />}
        showTooltip={collapsed}
        text={String(t("Navigation.newsEvents"))}
      />
      <NavigationButton
        href="/reports"
        icon={<PriorityHigh />}
        showTooltip={collapsed}
        text={String(t("Navigation.reports"))}
      />
      <NavigationButton
        href="/scratchcodes"
        icon={<Subtitles />}
        showTooltip={collapsed}
        text={String(t("Navigation.scratchcodes"))}
      />
      <NavigationButton
        href="/transactions"
        icon={<CurrencyExchange />}
        showTooltip={collapsed}
        text={String(t("Navigation.transactions"))}
      />
    </List>
  );
};
